module.exports = __webpack_public_path__ + "img/wxcj.093b5bc3.png";